import { useEffect, useState } from "react";
import { useNotificationInfo } from "@/Common/hooks/Notifications";

import { INotificationExtraInfo } from "@/Common/api/types/notifications";
import { INBOX_TAB } from "@/Constants/notificationsWidgetTabNames";

function useUnreadCount() {
	const { notificationInfo } = useNotificationInfo();
	const [unreadCount, setUnreadCount] = useState(0);
	const [currentTab, setCurrentTab] = useState(INBOX_TAB);

	const getUnreadCount = (notificationInfoParam: INotificationExtraInfo, currentTabParam: string) => {
		const totalUnreadCount = notificationInfoParam?.unreadCount ?? 0;
		const archivedUnreadCount = notificationInfoParam?.unreadArchivedCount ?? 0;
		const unreadCountForInbox = totalUnreadCount - archivedUnreadCount;
		if (currentTabParam === INBOX_TAB) {
			return unreadCountForInbox < 0 ? 0 : unreadCountForInbox;
		} else {
			return archivedUnreadCount;
		}
	};

	useEffect(() => {
		if (notificationInfo) {
			setUnreadCount(getUnreadCount(notificationInfo, currentTab));
		}
	}, [notificationInfo, currentTab]);

	return { unreadCount, setCurrentTab };
}

export { useUnreadCount };
